import OptionsTypeConfig from './OptionsTypeConfig';

export default class CheckGroupTypeConfig extends OptionsTypeConfig{

}
